import React from "react";
import { Button, List, ListItem, Paper, TextField, Typography } from "@mui/material";
import Flex from "../../components/Flex";
import WitsConceptInfo from "./WitsConceptInfo";
import LoadingPattern from "../../components/LoadingPattern";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { browseConcepts, selectBrowserConcepts } from "../../redux/slices/lensEditor";
import { nonEmpty } from "../../helpers/coll";
import { backend } from "Backend";

const ConceptBrowser = () => {
  const [query, setQuery] = React.useState("");

  const [idQuery, setIdQuery] = React.useState("");

  const dispatch = useAppDispatch();

  const [loading, setLoading] = React.useState(false);
  const concepts = useAppSelector(selectBrowserConcepts);

  const doLookup = async () => {
    setLoading(true);
    const response = await backend.conceptLookup([idQuery]);
    const match = response[0];
    if (match) {
      await dispatch(browseConcepts({ concepts: [match] }));
    }
    setLoading(false);
  };

  const doSearch = async () => {
    setLoading(true);
    const response = await backend.conceptSearch(query, 0, 200);
    if (response.concepts) {
      await dispatch(browseConcepts({ concepts: response.concepts }));
    }
    setLoading(false);
  };

  return (
    <Flex paddingTop={1}>
      <Flex flexDirection="row" width="100%" mb={2}>
        <TextField
          fullWidth
          label="Search by Name"
          value={query}
          onChange={(evt) => setQuery(evt.target.value)}
          onKeyPress={(evt) => {
            if (evt.key === "Enter") {
              doSearch();
            }
          }}
        />
        <Button size="small" onClick={doSearch}>
          Go
        </Button>
      </Flex>
      <Flex flexDirection="row" width="100%">
        <TextField
          fullWidth
          label="Lookup by ID"
          value={idQuery}
          onChange={(evt) => setIdQuery(evt.target.value)}
          onKeyPress={(evt) => {
            if (evt.key === "Enter") {
              doLookup();
            }
          }}
        />
        <Button size="small" onClick={doLookup}>
          Go
        </Button>
      </Flex>
      {nonEmpty(concepts) && <Typography>{concepts.length} Concepts</Typography>}
      {loading ? (
        <Flex p={2} centered width="100%" height="100%">
          <LoadingPattern />
        </Flex>
      ) : (
        <List>
          {concepts.map((concept) => (
            <ListItem sx={{ m: 1 }} component={Paper} key={concept.id}>
              <WitsConceptInfo concept={concept} />
            </ListItem>
          ))}
        </List>
      )}
    </Flex>
  );
};

export default ConceptBrowser;
